"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replaceProduct = void 0;
const replaceProduct = ({
  currentProductCode,
  fetchedGroupedProduct
}) => prevProducts => {
  const newProducts = [...prevProducts];
  const index = newProducts.findIndex(p => p.code === currentProductCode);
  if (index !== -1) {
    newProducts[index] = fetchedGroupedProduct;
  }
  return newProducts;
};
exports.replaceProduct = replaceProduct;
